import { useHandleAnalytics } from "../lib/analytics";
import { AnalyticEvents, AnalyticsBet } from "@fresh8/types/src/analytics";
import { usePixelMacros } from "../composition/pixelMacros";

export const useAnalytics = (
  props: {
    marketId?: string;
    eventId?: string;
    optionId?: string;
  },
  statsDesc: string
) => {
  const { getPixelUrl, getPixelMacroData, populatePixelUrl } = usePixelMacros();
  const $handleAnalytics = useHandleAnalytics();

  const handleClick = () => {
    const statsEvent = AnalyticEvents.CLICKED_THROUGH;
    const pixelData = getPixelMacroData(props);
    const bets =
      props.optionId && props.marketId
        ? [
            {
              betOptionID: props.optionId,
              betID: props.marketId
            }
          ]
        : [];
    const pixelUrl = getPixelUrl(statsEvent);

    $handleAnalytics(
      statsEvent,
      statsDesc,
      bets,
      pixelUrl
        ? pixelData
          ? populatePixelUrl(pixelData, pixelUrl)
          : pixelUrl.split("?")[0]
        : undefined
    );
  };

  const handleViewed = (bets: AnalyticsBet[]) => {
    const statsEvent = AnalyticEvents.VIEWED;
    const pixelUrl = getPixelUrl(statsEvent);

    $handleAnalytics(statsEvent, statsDesc, bets, pixelUrl);
  };

  return { handleClick, handleViewed };
};
